import React, { Component } from "react"
import { withStyles } from '@material-ui/core/styles';
import { TextField, Select, MenuItem, InputBase, InputAdornment, IconButton, FormControl, FormHelperText } from "@material-ui/core"
import Save from "../../../../Assets/img/svg/save.svg"
import Cancel from "../../../../Assets/img/svg/cancel.svg"
import image from "../../../../Assets/img/svg/Image.svg"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../Assets/jss/customStyle";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Delete from "../../../../Assets/img/svg/delete.svg"
import del from "../../../../Assets/img/svg/Del.svg"
import $ from "jquery"
import moment from "moment"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../../helpers/endpointService"
import deactive from '../../../../Assets/img/svg/deactive.svg';
import InnerImageZoom from "react-inner-image-zoom";
import { getSettingsFormat } from "../../../../actions/SettingsAction"
import { VesselStatus, inspectionSystem } from "../../../Constants";
import { addshipbasicinfo, filedeleteshiplogo, addshiplogoinfo, filedeleteship, putshipbasicinfo } from "../../../../actions/AddNewShipAction";
import { getInspectionTypeList, getStatusTypeList } from "../../../../actions/Lookup"
import { max } from "moment";
import { min } from "moment";
import {warningAlert} from "../../../custom/alert"
import { successToast, errorToast } from "../../../../actions/CommonFunction";

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

class FinalSubmit extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isMobile: false,
            ismandatory:false,
            menu: true,
            isEdit: false,
            isAccessControl: false,
            check: false,
            ShipId: 0,
            checkbox: false,
            completionDate: "",
            completionDate1:"",
            UserRole: "",
            Status: "",
            isInspectiontwo:false
        }
    };

    componentDidMount() {
        const { dispatch } = this.props;
        window.location.pathname === "/inspection/finalsubmit" ? this.state.isEdit = false : this.state.isEdit = true;
        localStorage.getItem("UserRoles")?.toLowerCase() == "admin" ? this.state.isAccessControl = false : this.state.isAccessControl = true;
        // this.state.completionDate = moment(new Date()).format("yyyy-MM-DD");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.ShipId = localStorage.getItem("DashId");
        this.setState({})
        window.addEventListener("resize", this.resize.bind(this));
        this.getshipbasicinfo(localStorage.getItem("DashId"))
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
        console.log(this.state.completionDate)
    }

    getshipbasicinfo = (data) => {
        let apiUrl = API.GET_SHIP + "/id?id=" + data;
        axios({
            method: "get",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    console.log(response.data)
                    this.state.Status = response.data?.Status;
                    this.setState({})
                    if (this.state.isEdit == true && this.state.Status == "Reviewed and Approved") {
                        this.state.checkbox = true;
                    }
                    if (this.state.isEdit == false && this.state.Status == "Inspection Completed") {
                        this.state.checkbox = true;
                    }
                    this.setState({})
                    // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            });

    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#BI .MuiListItemText-primary").removeClass("fw-bolder")
        $("#BIL").removeClass("active-color")
    }
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            if (this.state.isEdit == true) {
                this.props.navigate("/sidebareditship");
            }
            else {
                this.props.navigate("/sidebar");
            }
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        if (this.state.isEdit == true) {
            this.props.navigate("/sidebareditship");
        }
        else {
            this.props.navigate("/sidebaraddship");
        }
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };

    resize1 = () => {
        $("#FinalSubmit1 .MuiListItemText-primary").addClass("fw-bolder")
        $("#FinalSubmit1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#FinalSubmit").removeClass("d-none")
        $("#FinalSubmit").addClass("d-block")
        $("#FS .MuiListItemText-primary").addClass("fw-bolder")
        $("#FS").addClass("active-color")
    };

    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/shiplist`)
        }
    }

    AddCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate(`/shiplist`)
    };

    handleInputChange = (e, node) => {
        this.state.check = e.target.checked;
        this.setState({})
    };

    handleInputChange1 = (e, node) => {
        if(e.target.value !==""){
            this.state.ismandatory=false;
            this.setState({})
        }
        this.state.completionDate = e.target.value;
        this.setState({})

    };
    handleInputInspectionDateChange=(e)=>{
        this.state.completionDate1=e.target.value
        this.setState({})
    }
    handleCheckInspectionNew=()=>{
        if(this.state.completionDate !==""){
            this.state.isInspectiontwo=true;
            this.setState({})
        }else{
            this.state.ismandatory=true;
            this.setState({})
        }
       
    }

    Save = () => {
        if (this.state.isEdit == true) {
            this.UpdateStatus(this.state.ShipId, "Reviewed and Approved", this.state.UserRole, moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));
        }
        if (this.state.isEdit == false) {
            this.UpdateStatus(this.state.ShipId, "Inspection Completed", this.state.UserRole, this.state.completionDate,this.state.completionDate1);
        }
    };

    UpdateStatus = (shipid, status, role, date,date1) => {
        let DateArray=[]
        if(date !==""&&date1 !==""){
            DateArray.push(date,date1); 
        }
        else if(date !==""){
            DateArray.push(date);
        }else if(date1 !==""){
            DateArray.push(date1)
        }
       const InspectionDate= DateArray.toString();
        let apiUrl = API.UPDATE_STATUS + "?id=" + shipid + "&status=" + status + "&modify=" + role + "&date=" + InspectionDate;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "put",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    console.log(response.data)
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                    this.props.navigate(`/shiplist`)
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                // warningAlert("Something went wrong. Please try again.");
       errorToast();
       this.props.dispatch({ type: "CANCEL", data: true });
                if (error?.response?.status === 401) {
                }
            });

    };


    render() {
        const { isError1, isError2, isError3, isError4, isEdit, addData, isAccessControl } = this.state;
        let { classes, shipStatus, menuToggle, statusType, inspectionType } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4 mob-topfixed ">
                                <div className="col-7 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"Basic" + "1"} className='textNaviIcon' primary={this.state.isEdit ? "Edit Ship" : "Inspection Tasks"} />
                                            <NavigateNextIcon id="Basic" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-5 pt-2 mt-5 ">
                                    <h4 className="pt-2">{this.state.isEdit ? "Final Submit" : "Submit"}</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto mt-130 scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -75 }}>
                    {this.state.isMobile ? (
                        <table className="dataTable border-top" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center">
                                        <i
                                            class="fa fa-arrow-left cursorPointer"
                                            onClick={this.AddCancel1}
                                        ></i>
                                    </td>
                                    <td width="95%" className="border-right" >
                                        <button className={`${classes.button}`} disabled={this.state.check ? false : true} onClick={() => { this.Save() }}><img src={Save} style={{ marginTop: '-4px', opacity: this.state.check ? "" : "0.5" }}></img>&nbsp;{this.state.isEdit ? "Final Submit" : "Submit"}</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    ) : (
                        <>
                            <table className="dataTable" width="100%">
                                <tbody>
                                    <tr>
                                        <td width="5%" className="border-right text-center">
                                            <i
                                                class="fa fa-arrow-left cursorPointer"
                                                onClick={this.AddCancel1}
                                            ></i>
                                        </td>
                                        <td className="" width="95%">
                                            <button className={`${classes.button}`} disabled={this.state.check ? false : true} onClick={() => this.Save()}><img src={Save} style={{ marginTop: '-4px', opacity: this.state.check ? "" : "0.5" }}></img>&nbsp;{this.state.isEdit ? "Final Submit" : "Submit"}</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                    )}
                    {window.location.pathname == "/inspection/finalsubmit" ?
                        <div  style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                            {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">Submit</h6>}
                            <div className={this.state.isMobile ? "row mx-1 mt-4" : "row mx-1 px-2 mt-4"}>
                                <div className="col-12 mb-3 input-group">
                                    <label class="contCheck pr-4">
                                        <input type="checkbox" disabled={this.state.checkbox ? true : false} checked={this.state.check ? true : false} onChange={(e) => this.handleInputChange(e, "Reviewed and Approved")}></input>
                                        <span class="checkmark "></span>
                                    </label>
                                    <span className={window.innerWidth < 570 ? "mt-3" : "pl-2"} style={{ fontSize: '14px', fontWeight: '800px' }}>Are you sure all sections have been completed? Please review and click submit?</span>
                                </div>
                                {this.state.check ? <>
                                    <div id="completeddate" className={`col-12 col-sm-12 col-lg-2 col-xl-1 ${this.state.isMobile ? "col-md-12 mt-2" : "col-md-3  px-0 pt-3"} `} >
                                        <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 pl-3"}>Inspection Date1&nbsp;:
                                        </label>
                                    </div>
                                    <div id="completeddate1" className={`col-12 col-sm-12 col-lg-5 col-xl-3  ${this.state.isMobile ? "col-md-12 pt-1 pb-3" : "col-md-6 pb-4 pt-3"} `} >
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="date"
                                            id="type-date"
                                            value={this.state.completionDate && moment(this.state.completionDate).format("yyyy-MM-DD") != "0001-00-01" && moment(this.state.completionDate).format("yyyy-MM-DD") != "0001-01-01" && moment(this.state.completionDate).format("yyyy") != "0001" && moment(this.state.completionDate).format("yyyy-MM-DD")}
                                            placeholder={this.state.completionDate && moment(this.state.completionDate).format("yyyy-MM-DD") != "0001-00-01" && moment(this.state.completionDate).format("yyyy-MM-DD") != "0001-01-01" && moment(this.state.completionDate).format("yyyy") != "0001" ? moment(this.state.completionDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY") : ""}
                                            onChange={(e) => { this.handleInputChange1(e, "completionDate") }}
                                            InputProps={{ className: `border-radius ${classes.inputfieldAlign}`,style: { fontSize: 12 },
                                            inputProps:{max:`${moment(this.state.completionDate1, 'yyyy-MM-DD').subtract(1,'days').format("yyyy-MM-DD")}`}
                                            
                                       }}/>
                                      {this.state.ismandatory? <span className="mandatory-text">Please select inspection date1.</span>:<></>}
                                     </div> 
                                     <div id="completeddate" className={`col-lg-4 col-xl-2 ${this.state.isMobile ? "col-md-12 mt-1" : "col-md-3 px-0 inspectioDateAdd"} `} >
                                     <button className={classes.button} disabled={this.state.isInspectiontwo?true:false} onClick={this.handleCheckInspectionNew}><i className="fa fa-plus pr-2" style={{ color: "#499AC8" }}></i>Add New Inspection Date</button>
                                    </div>
                                     </> : <></>}
                                    {this.state.isInspectiontwo ? <>
                                    <div id="completeddate" className={`col-12 col-sm-12  col-md-3 col-lg-2 col-xl-1 ${this.state.isMobile ? "col-md-12 mt-2" : "col-md-2  px-0 pt-3"} `} >
                                        <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 pl-3"}>Inspection Date2&nbsp;:
                                        </label>
                                    </div>
                                    <div id="completeddate1" className={`col-12 col-sm-12  col-lg-5 col-xl-3  ${this.state.isMobile ? "col-md-12 pt-1 pb-3" : "col-md-6 pb-4 pt-3"} `} >
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="date"
                                            id="type-date"
                                            value={this.state.completionDate1 && moment(this.state.completionDate1).format("yyyy-MM-DD") != "0001-00-01" && moment(this.state.completionDate1).format("yyyy-MM-DD") != "0001-01-01" && moment(this.state.completionDate1).format("yyyy") != "0001" && moment(this.state.completionDate1).format("yyyy-MM-DD")}
                                            placeholder={this.state.completionDate1 && moment(this.state.completionDate1).format("yyyy-MM-DD") != "0001-00-01" && moment(this.state.completionDate1).format("yyyy-MM-DD") != "0001-01-01" && moment(this.state.completionDate1).format("yyyy") != "0001" ? moment(this.state.completionDate1).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY") : ""}
                                            onChange={(e) => { this.handleInputInspectionDateChange(e, "completionDate1") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                inputProps:{min:`${moment(this.state.completionDate, 'yyyy-MM-DD').add(1,'days').format("yyyy-MM-DD")}`},
                                             style: { fontSize: 12 }
                                            }}
                                        />
                                         
                                    </div> </> : <></>}
                                {/* <div className={`row mx-1 align-items-center mb-3 ${this.state.isMobile ? "" : ""}`}>
                                    <div className={`col-1 col-sm-1  col-lg-1 col-xl-1 col-md-1 ${this.state.isMobile ? "col-md-1 pt-2" : "col-1 col-sm-1  col-lg-1 col-xl-1 mt-4 col-md-1 "}`}>
                                        <label class="contCheck pr-4">
                                            <input type="checkbox" disabled={this.state.checkbox ? true : false}  checked={this.state.check ? true : false} onChange={(e) => this.handleInputChange(e, "Reviewed and Approved")}></input>
                                            <span class="checkmark "></span>
                                        </label>
                                    </div>
                                    <div className={`col-11 col-sm-11  col-lg-11 col-xl-11 col-md-11 ${this.state.isMobile ? "col-md-11 pt-4" : "col-1 col-sm-11  col-lg-11 col-xl-11 mt-3 col-md-11 mt-4 pt-3"}`} style={{marginLeft :this.state.isMobile ? '' : '-75px'}}>
                                        <span style={{fontSize : '14px', fontWeight : '800px'}}>Are you sure all sections have been completed? Please review and click submit?</span>
                                    </div>
                                    {this.state.check ? <>
                                        <div id="completeddate" className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "col-md-12 mt-2" : "col-md-2  px-0 "} `} >
                                            <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-n1 pl-3"}>Inspection Date&nbsp;:
                                            </label>
                                        </div>
                                        <div id="completeddate1" className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"} `} >
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                type="date"
                                                id="type-date"
                                                value={this.state.completionDate && moment(this.state.completionDate).format("yyyy-MM-DD") != "0001-00-01" && moment(this.state.completionDate).format("yyyy-MM-DD") != "0001-01-01" && moment(this.state.completionDate).format("yyyy") != "0001" && moment(this.state.completionDate).format("yyyy-MM-DD")}
                                                placeholder={this.state.completionDate && moment(this.state.completionDate).format("yyyy-MM-DD") != "0001-00-01" && moment(this.state.completionDate).format("yyyy-MM-DD") != "0001-01-01" && moment(this.state.completionDate).format("yyyy") != "0001" ? moment(this.state.completionDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY") : ""}
                                                onChange={(e) => { this.handleInputChange1(e, "completionDate") }}
                                                InputProps={{
                                                    className: `border-radius ${classes.inputfieldAlign}`,
                                                    style: { fontSize: 12 }
                                                }}
                                            />
                                        </div> </> : <></>}
                                </div> */}
                            </div>
                        </div> : <div  style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                            {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">Final Submit</h6>}
                            <div className={this.state.isMobile ? "row mx-1 mt-4" : "row mx-1 px-2 mt-4"}>
                                <div className="col-12 mb-3 input-group">
                                    <label class="contCheck pr-4">
                                        <input type="checkbox" disabled={this.state.checkbox ? true : false} checked={this.state.check ? true : false} onChange={(e) => this.handleInputChange(e, "Inspection Completed")}></input>
                                        <span class="checkmark "></span>
                                    </label>
                                    <span className={window.innerWidth < 290 ? "mt-3" : "pl-2"} style={{ fontSize: '14px', fontWeight: '800px' }}>Is the report ready to be published?</span>
                                </div>
                                {/* <div className={`col-1 col-sm-1  col-lg-1 col-xl-1 col-md-1 ${this.state.isMobile ? "col-md-1 pt-2" : "col-1 col-sm-1  col-lg-1 col-xl-1 mt-4 col-md-1 "}`}>
                                        <label class="contCheck pr-4">
                                            <input type="checkbox" disabled={this.state.checkbox ? true : false} checked={this.state.check ? true : false} onChange={(e) => this.handleInputChange(e, "Inspection Completed")}></input>
                                            <span class="checkmark "></span>
                                        </label>
                                    </div>
                                    <div className={`col-11 col-sm-11  col-lg-11 col-xl-11 col-md-11 ${this.state.isMobile ? "col-md-11 pt-4" : "col-1 col-sm-11  col-lg-11 col-xl-11 mt-3 col-md-11 mt-4 pt-3"}`} style={{ marginLeft: this.state.isMobile ? '' : '-75px' }}>
                                        <span style={{ fontSize: '14px', fontWeight: '800px' }}>Is the report ready to be published?</span>
                                    </div> */}
                            </div>
                        </div>}
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Changes are not saved yet. The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#499AC8", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],
        alertCancel: state.commonReducer.alertCancel || [],
        statusType: state.lookupReducer.statusType || [],
        inspectionType: state.lookupReducer.inspectionType || []

    };
}

// AddBI.propTypes = {
//     classes: PropTypes.object.isRequired,
// }

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(FinalSubmit))
);